import type { PropsWithChildren } from 'react'
import React from 'react'
import { rem } from 'polished'
import styled from 'styled-components'
import { mediaQueryUp } from 'components/utils/breakpoint'
import Group from 'components/utils/Group'

// Custom CSS properties for modal-specific overrides
export const LESA_PURCHASE_SUMMARY_PADDING_VAR = '--lesa-purchase-summary-padding'
export const LESA_PURCHASE_SUMMARY_MAX_WIDTH_VAR = '--lesa-purchase-summary-max-width'
export const LESA_PURCHASE_SUMMARY_WIDTH_VAR = '--lesa-purchase-summary-width'

const Container = styled(Group)`
  background-color: ${props => props.theme.palette.neutral.default.eight};
  border: 1px solid ${props => props.theme.palette.neutral.default.five};
  border-radius: ${props => props.theme.borderRadius.M};
  padding: var(${LESA_PURCHASE_SUMMARY_PADDING_VAR}, ${rem(20)});
  max-width: var(${LESA_PURCHASE_SUMMARY_MAX_WIDTH_VAR}, ${rem(440)});
  width: var(${LESA_PURCHASE_SUMMARY_WIDTH_VAR}, 80%);

  ${mediaQueryUp.tablet} {
    width: var(${LESA_PURCHASE_SUMMARY_WIDTH_VAR}, ${rem(500)});
  }
`

type Props = PropsWithChildren<{}>

export default function LesaPurchaseSummaryContainer(props: Props) {
  const { children } = props

  return (
    <Container direction="vertical" fullWidth>
      {children}
    </Container>
  )
}
